import { render, staticRenderFns } from "./socket-state.vue?vue&type=template&id=282d3bb7&scoped=true&"
import script from "./socket-state.vue?vue&type=script&lang=ts&"
export * from "./socket-state.vue?vue&type=script&lang=ts&"
import style0 from "./socket-state.vue?vue&type=style&index=0&id=282d3bb7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d3bb7",
  null
  
)

export default component.exports